/* sm-fit-ui.js
   Builds the "Will it fit?" form for each [data-sm-fit] block inside a modal, runs
   SMFit.evaluate, and shows the result per size. The launch button moves into Know Your
   Space: an element marked data-sm-fit-launch if present, otherwise right after the
   .sm-dims4__heading. Guest copy lives here; the math lives in sm-fit-engine.js.
   All measurements in inches. Nothing is stored or sent anywhere. */
(function () {
  'use strict';

  var STEP_TYPES = {
    door:            { name: 'Doorway',                     fields: [['width', 'Width with the door fully open']] },
    hall:            { name: 'Hallway',                     fields: [['width', 'Narrowest width']] },
    stairs_straight: { name: 'Straight stairs',             fields: [['width', 'Narrowest width (railings included)']] },
    stairs_landing:  { name: 'Stairs with a landing turn',  fields: [['fromWidth', 'Stair width'], ['toWidth', 'Landing width']] },
    stairs_winding:  { name: 'Winding or spiral stairs',    fields: [] },
    elevator:        { name: 'Elevator',                    fields: [['doorWidth', 'Door width'], ['cabWidth', 'Inside width'], ['cabDepth', 'Inside depth'], ['cabHeight', 'Inside height']] }
  };

  var VERDICT = { fits: 'Fits', tight: "Tight, let's check it together", no_fit: "Won't fit" };

  function inches(s) {
    if (s === null || s === undefined) return null;
    var str = String(s), n = parseFloat(str);
    if (!isFinite(n)) return null;
    if (/\bcm\b|centimet/i.test(str)) return n / 2.54;
    if (/\bmm\b|millimet/i.test(str)) return n / 25.4;
    if (/\bft\b|feet|foot/i.test(str)) return n * 12;
    return n;
  }

  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }

  function fmt(n) { return String(Math.round(n * 100) / 100); }

  function joinList(items) {
    if (items.length <= 1) return items.join('');
    return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
  }

  function init(root) {
    if (root.getAttribute('data-sm-fit-ready')) return;
    root.setAttribute('data-sm-fit-ready', '1');
    var dataEl = root.querySelector('[data-sm-fit-product]');
    if (!dataEl || !window.SMFit) return;
    var p;
    try { p = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var product = {
      kind: p.kind,
      shipsInPieces: !!p.shipsInPieces,
      moveIn: inches(p.moveIn),
      openDepth: inches(p.openDepth),
      depth: inches(p.depth),
      sizes: (p.sizes || []).map(function (s) { return { key: s.key, label: s.label, width: inches(s.width) }; })
    };
    if (!product.moveIn || !product.sizes.length) { root.style.display = 'none'; return; }

    // Grab everything before the modal moves out of root.
    var launch = root.querySelector('[data-sm-fit-open]');
    var modal = root.querySelector('[data-sm-fit-modal]');
    var introEl = root.querySelector('[data-sm-fit-intro]');
    var body = root.querySelector('[data-sm-fit-body]');
    if (!launch || !modal || !introEl || !body) return;

    // The modal lives on <body> so page containers can never clip it.
    document.body.appendChild(modal);

    // The button lives inside Know Your Space when it is on the page.
    var hook = document.querySelector('[data-sm-fit-launch]');
    var kysHeading = document.querySelector('.sm-dims4__heading');
    if (hook) hook.appendChild(launch);
    else if (kysHeading && kysHeading.parentNode) kysHeading.parentNode.insertBefore(launch, kysHeading.nextSibling);
    launch.hidden = false;

    var prevOverflow = '';
    function openModal() {
      modal.hidden = false;
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      var first = modal.querySelector('input, select, button.sm-fit__btn');
      if (first) first.focus();
    }
    function closeModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.style.overflow = prevOverflow;
      launch.focus();
    }
    launch.addEventListener('click', openModal);
    Array.prototype.forEach.call(modal.querySelectorAll('[data-sm-fit-close]'), function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && !modal.hidden) closeModal(); });

    var isSleeper = p.kind === 'sleeper';
    var thing = isSleeper ? 'sofa' : 'chair';
    var sizeNames = product.sizes.map(function (s) { return s.label; });

    introEl.textContent = isSleeper && product.sizes.length > 1
      ? 'Measure the way in and your room, and we will check every size of the ' + p.model + ' (' + joinList(sizeNames) + ') at once. All measurements in inches.'
      : 'Measure the way in and your room, and we will check the ' + p.model + ' for you. All measurements in inches.';

    var steps = [];

    // Way in
    var pathCard = el('div', { 'class': 'sm-fit__card' });
    pathCard.appendChild(el('h3', null, '1. The way in'));
    pathCard.appendChild(el('p', { 'class': 'sm-fit__tip' },
      'Your ' + thing + ' travels on its back with the legs off, so width is what matters. Measure each doorway with the door fully open, at its narrowest point, usually between the door stops, and tell us if it is a straight shot. Add every spot it passes on the way to the room.'));
    var restoredTip = el('p', { 'class': 'sm-fit__tip' }, 'We filled in the measurements you entered last time on this device. Check them over, then tap Check the fit.');
    restoredTip.hidden = true;
    pathCard.appendChild(restoredTip);
    var list = el('div');
    pathCard.appendChild(list);

    var add = el('div', { 'class': 'sm-fit__add' });
    var sel = el('select', { 'aria-label': 'Add a spot on the way in' });
    sel.appendChild(el('option', { value: '' }, 'Add a spot on the way in...'));
    Object.keys(STEP_TYPES).forEach(function (k) { sel.appendChild(el('option', { value: k }, STEP_TYPES[k].name)); });
    sel.addEventListener('change', function () { if (sel.value) { addStep(sel.value); sel.value = ''; } });
    add.appendChild(sel);
    pathCard.appendChild(add);
    body.appendChild(pathCard);

    var uid = 0;
    function numField(container, step, key, label) {
      var lab = el('label', { 'class': 'sm-fit__field' });
      lab.appendChild(el('span', null, label));
      var inp = el('input', { type: 'number', inputmode: 'decimal', min: '0', step: '0.25', placeholder: 'inches' });
      lab.appendChild(inp);
      container.appendChild(lab);
      step.inputs[key] = inp;
    }

    function addStep(type, name) {
      var def = STEP_TYPES[type];
      var count = steps.filter(function (s) { return s.type === type; }).length + 1;
      var step = { type: type, name: name || (def.name + (count > 1 ? ' ' + count : '')), inputs: {} };
      var row = el('div', { 'class': 'sm-fit__row' });
      var head = el('div', { 'class': 'sm-fit__row-name' });
      head.appendChild(el('span', null, step.name));
      var rm = el('button', { type: 'button', 'class': 'sm-fit__remove' }, 'Remove');
      rm.addEventListener('click', function () { steps.splice(steps.indexOf(step), 1); list.removeChild(row); save(); });
      head.appendChild(rm);
      row.appendChild(head);
      if (!def.fields.length) row.appendChild(el('span', { 'class': 'sm-fit__tip' }, 'No measurement needed; we always look at these with you.'));
      def.fields.forEach(function (f) { numField(row, step, f[0], f[1]); });
      if (type === 'door') {
        var ask = el('div', { 'class': 'sm-fit__ask' });
        ask.appendChild(el('span', null, 'Is it a straight shot through this doorway, with room in front to line the ' + thing + ' up on its back?'));
        var choice = el('div', { 'class': 'sm-fit__choice' });
        var more = el('div', { 'class': 'sm-fit__more' });
        more.hidden = true;
        var group = 'sm-fit-straight-' + (++uid);
        var radios = {};
        [['yes', 'Yes'], ['no', 'No']].forEach(function (c) {
          var lab = el('label');
          var radio = el('input', { type: 'radio', name: group, value: c[0] });
          radio.addEventListener('change', function () { step.straight = c[0] === 'yes'; more.hidden = step.straight; });
          radios[c[0]] = radio;
          lab.appendChild(radio);
          lab.appendChild(el('span', null, c[1]));
          choice.appendChild(lab);
        });
        ask.appendChild(choice);
        row.appendChild(ask);
        more.appendChild(el('p', { 'class': 'sm-fit__tip' }, 'Measure the open floor in front of the doorway, from the opening straight back to the wall or whatever is behind you, and how tall the doorway is.'));
        numField(more, step, 'spaceInFront', 'Space in front of the doorway');
        numField(more, step, 'doorHeight', 'Doorway height');
        row.appendChild(more);
        step.setStraight = function (v) { step.straight = v; more.hidden = v; radios[v ? 'yes' : 'no'].checked = true; };
      }
      steps.push(step);
      list.appendChild(row);
      return step;
    }

    // Room
    var roomCard = el('div', { 'class': 'sm-fit__card' });
    roomCard.appendChild(el('h3', null, '2. Your room'));
    var roomRow = el('div', { 'class': 'sm-fit__row' });
    function roomField(label) {
      var lab = el('label', { 'class': 'sm-fit__field' });
      lab.appendChild(el('span', null, label));
      var inp = el('input', { type: 'number', inputmode: 'decimal', min: '0', step: '0.25', placeholder: 'inches' });
      lab.appendChild(inp);
      roomRow.appendChild(lab);
      return inp;
    }
    var wallInp = roomField('Length of the wall it goes on');
    var floorInp = roomField(isSleeper ? 'Open floor from that wall (for the bed)' : 'Open floor from that wall (to recline)');
    roomCard.appendChild(roomRow);
    if (product.openDepth) {
      roomCard.appendChild(el('p', { 'class': 'sm-fit__tip' },
        (isSleeper ? 'Open as a bed, it reaches ' : 'Fully reclined, it reaches ') + fmt(product.openDepth) + ' inches from the wall.'));
    }
    body.appendChild(roomCard);

    var btn = el('button', { type: 'button', 'class': 'sm-fit__btn' }, 'Check the fit');
    body.appendChild(btn);
    var reset = el('button', { type: 'button', 'class': 'sm-fit__remove' }, 'Start over');
    reset.style.marginLeft = '14px';
    body.appendChild(reset);

    // Measurements are remembered in this guest's own browser only, so every product page
    // pre-fills them. Nothing is sent anywhere.
    var STORE = 'sm-fit-measurements-v1';
    function save() {
      try {
        var data = {
          steps: steps.map(function (s) {
            var v = {};
            Object.keys(s.inputs).forEach(function (k) { v[k] = s.inputs[k].value; });
            return { type: s.type, name: s.name, straight: s.straight, values: v };
          }),
          room: { wallLength: wallInp.value, floorDepth: floorInp.value }
        };
        window.localStorage.setItem(STORE, JSON.stringify(data));
      } catch (e) {}
    }
    function load() {
      try { var raw = window.localStorage.getItem(STORE); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
    }
    function restore(data) {
      var any = false;
      ((data && data.steps) || []).forEach(function (sv) {
        if (!sv || !STEP_TYPES[sv.type]) return;
        var st = addStep(sv.type, sv.name);
        Object.keys(sv.values || {}).forEach(function (k) { if (st.inputs[k]) st.inputs[k].value = sv.values[k]; });
        if (sv.type === 'door' && typeof sv.straight === 'boolean') st.setStraight(sv.straight);
        any = true;
      });
      if (data && data.room) {
        wallInp.value = data.room.wallLength || '';
        floorInp.value = data.room.floorDepth || '';
      }
      return any;
    }
    if (restore(load())) restoredTip.hidden = false; else addStep('door', 'Front door');
    body.addEventListener('input', save);
    body.addEventListener('change', save);
    reset.addEventListener('click', function () {
      try { window.localStorage.removeItem(STORE); } catch (e) {}
      steps.length = 0;
      list.innerHTML = '';
      wallInp.value = '';
      floorInp.value = '';
      out.innerHTML = '';
      out.style.display = 'none';
      restoredTip.hidden = true;
      addStep('door', 'Front door');
    });
    var out = el('div', { 'class': 'sm-fit__card', 'aria-live': 'polite' });
    out.style.display = 'none';
    body.appendChild(out);

    function val(inp) { var v = inp.value.trim(); return v === '' ? null : parseFloat(v); }

    function reasonText(c, step, size) {
      var where = step ? step.name.toLowerCase() : '';
      var turn = step && step.type === 'stairs_landing' ? 'the turn at the stair landing' : step && step.type === 'door' ? 'the turn into the ' + where : 'the turn from the hallway into the doorway';
      switch (c.reason) {
        case 'opening_clear':         return 'Clears the ' + where + '.';
        case 'opening_within_margin': return 'The ' + where + ' is within half an inch of the ' + fmt(product.moveIn) + ' inch move-in width. We would like to look at this one with you.';
        case 'opening_too_narrow':    return 'The ' + where + ' is narrower than the ' + fmt(product.moveIn) + ' inch move-in width.';
        case 'turn_clear':            return 'Makes ' + turn + (step && step.type === 'door' ? ' on its back.' : '.');
        case 'on_end_clear':          return 'Makes ' + turn + ' on its end. Our crew stands it up in the space in front and tilts it through.';
        case 'turn_too_tight':        return 'At ' + fmt(size.width) + ' inches long, ' + turn + ' is too tight on paper, on its back or on its end. Let us look at it together.';
        case 'straight_unanswered':   return 'Let us know if the ' + where + ' is a straight shot so we can check it.';
        case 'turn_needs_tilt':       return 'At ' + fmt(size.width) + ' inches long, ' + turn + ' is tight. Our crew may be able to angle it through, so let us check it together.';
        case 'pieces_width_only':     return 'It arrives in pieces, so only the width matters at the ' + (step && (step.type === 'turn' || step.type === 'stairs_landing') ? turn.replace('the turn', 'turn') : where) + ', and it clears.';
        case 'winding_stairs':        return 'Winding or spiral stairs always need a closer look from us.';
        case 'cab_floor_clear':
        case 'cab_on_end_clear':      return 'Fits in the elevator.';
        case 'cab_too_small':         return 'At ' + fmt(size.width) + ' inches long, it is tight in the elevator cab.';
        case 'missing_measurement':   return 'Add the measurements for the ' + where + ' so we can check it.';
        case 'wall_clear':            return 'Fits the wall.';
        case 'wall_within_margin':    return 'Fits the wall with less than 2 inches to spare.';
        case 'wall_too_short':        return 'At ' + fmt(size.width) + ' inches wide, it is longer than the wall.';
        case 'floor_clear':           return (isSleeper ? 'Room to open the bed' : 'Room to recline') + (c.note === 'little_walk_room' ? ', with little walking room past it.' : '.');
        case 'bed_does_not_open':     return 'The bed needs ' + fmt(product.openDepth) + ' inches from the wall to open.';
        case 'does_not_recline':      return 'It needs ' + fmt(product.openDepth) + ' inches from the wall to recline fully.';
        default:                      return '';
      }
    }

    // Store contact from Shopify Settings: shop.phone and shop.email, never typed into code.
    function contactLine() {
      var line = el('p', { 'class': 'sm-fit__contact' });
      if (p.phone) {
        line.appendChild(document.createTextNode('Text / Call '));
        line.appendChild(el('a', { href: 'tel:' + String(p.phone).replace(/[^0-9+]/g, '') }, p.phone));
      }
      if (p.email) {
        line.appendChild(document.createTextNode(p.phone ? ' or ' : 'Email '));
        line.appendChild(el('a', { href: 'mailto:' + p.email }, p.email));
      }
      return line;
    }

    btn.addEventListener('click', function () {
      var answers = {
        path: steps.map(function (s) {
          var o = { type: s.type };
          if (s.type === 'door') o.straight = s.straight;
          Object.keys(s.inputs).forEach(function (k) { o[k] = val(s.inputs[k]); });
          return o;
        }),
        room: { wallLength: val(wallInp), floorDepth: val(floorInp) }
      };
      var r = window.SMFit.evaluate(product, answers);
      out.innerHTML = '';
      out.style.display = '';
      if (!r.ok) { out.appendChild(el('p', null, 'We could not check this one online. Please contact us and we will help.')); return; }

      var passing = r.sizes.filter(function (s) { return s.verdict === 'fits'; }).map(function (s) { return s.label; });
      var summary;
      if (r.best === 'fits') {
        summary = r.sizes.length > 1
          ? 'Good news: the ' + joinList(passing) + ' ' + (passing.length > 1 ? 'fit' : 'fits') + ' everything you measured.'
          : 'Good news: it fits everything you measured.';
      } else if (r.best === 'tight') {
        summary = 'It is close. Reach out and we will go over it together.';
      } else {
        summary = (r.sizes.length > 1 ? 'None of the sizes clear' : 'It does not clear') + ' everything you measured. Reach out and we will help you find one that does.';
      }
      out.appendChild(el('p', { 'class': 'sm-fit__summary' }, summary));
      if (r.sizes.some(function (s) { return s.verdict !== 'fits'; }) && (p.phone || p.email)) out.appendChild(contactLine());

      r.sizes.forEach(function (s) {
        var box = el('div', { 'class': 'sm-fit__size' });
        var head = el('div', { 'class': 'sm-fit__size-head' });
        head.appendChild(el('span', null, (r.sizes.length > 1 ? p.model + ' ' + s.label : p.model) + ' (' + fmt(s.width) + ' in wide)'));
        head.appendChild(el('span', { 'class': 'sm-fit__badge sm-fit__badge--' + s.verdict }, VERDICT[s.verdict]));
        box.appendChild(head);
        var ul = el('ul', { 'class': 'sm-fit__reasons' });
        var seen = {};
        s.checks.forEach(function (c) {
          var t = reasonText(c, c.check === 'path' ? steps[c.step] : null, s);
          if (t && !seen[t]) { seen[t] = 1; ul.appendChild(el('li', null, t)); }
        });
        box.appendChild(ul);
        out.appendChild(box);
      });
      out.appendChild(el('p', { 'class': 'sm-fit__tip' }, 'This is a guide based on the measurements you entered. Measure carefully, and when in doubt, check with us before ordering.'));
      if (out.scrollIntoView) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-sm-fit]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
